import { BaseEditViewStore } from 'core/stores';
import { FacilityOrderTemplateNewFlowUSIntakeMissingProductNoteModalForm } from 'application/facility-order-new-flow-us-intake/forms';
import { FacilityOrderTemplateService } from "application/facility-order/services";
import { action, observable } from "mobx";

class FacilityOrderTemplateNewFlowUSIntakeMissingProductNoteModalStore extends BaseEditViewStore {
    @observable accessor disabled = false;
    constructor(rootStore, componentProps) {
        const facilityOrderTemplateService = new FacilityOrderTemplateService(rootStore.application.baasic.apiClient);
        const facilityOrderTemplate = componentProps.modalParams.data.facilityOrderTemplate;
        super(rootStore, {
            name: 'facility-order-template-us-intake-add-missing-product-note-modal',
            Form: FacilityOrderTemplateNewFlowUSIntakeMissingProductNoteModalForm,
            id: facilityOrderTemplate.id,
            actions: () => {
                return {
                    get: async () => {
                        return facilityOrderTemplate;
                    },
                    update: async (resource) => {
                        const response = await facilityOrderTemplateService.updatePortalNote({ ...resource });
                        return response.data;
                    },
                }
            },
            FormClass: FacilityOrderTemplateNewFlowUSIntakeMissingProductNoteModalForm
        });

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.facilityOrderTemplate = facilityOrderTemplate;
        this.facilityOrderTemplateService = facilityOrderTemplateService;
        this.showTemplateChangeWarning = this.modalParams.data.showTemplateChangeWarning;
    }

    @action.bound
    async resolveMissingProductNote() {
        this.disabled = true;
        await this.facilityOrderTemplateService.resolveMissingProductNote({ id: this.facilityOrderTemplate.id });
        this.facilityOrderTemplate.missingProduct = false;
        this.facilityOrderTemplate.missingProductNote = null;
        if(this.showTemplateChangeWarning)
            this.showTemplateChangeWarning();
        this.modalParams.close();
        this.disabled = false;
    }

    @action.bound
    async updateResource(resource) {
        if (!this.actions.update) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            if (resource.missingProductNote === null || resource.missingProductNote === undefined || resource.missingProductNote === '') {
                await this.resolveMissingProductNote();
            }
            else {
                await this.facilityOrderTemplateService.updateMissingProductNote({
                    id: this.id,
                    ...resource
                });

                this.facilityOrderTemplate.missingProductNote = resource.missingProductNote;
                this.form.setFieldsDisabled(false);
                this.modalParams.close();
            }
            
            if(this.showTemplateChangeWarning)
                this.showTemplateChangeWarning();
        }
        catch (err) {
            this.form.setFieldsDisabled(false);
            return this.onUpdateError(err);
        }
    }
}

export default FacilityOrderTemplateNewFlowUSIntakeMissingProductNoteModalStore;
